export const TEMPLATE_ROW_SM = 96;

export const TEMPLATE_ROW_LG = 108;

export const TEMPLATE_TYPES_LABEL = {
  getMyTemplates: 'template',
  getViboTemplates: 'publicTemplates',
  getCompanyTemplates: 'companyTemplates',
};
